import styled from 'styled-components';

export const NoticeStyles = styled.div`
  margin-bottom: 1rem;
  background: #fff6f6;
  width: 100%;
  border: 1px solid ${props => props.theme.border};
  border-radius: 0.2rem;
  p {
    color: ${props => props.theme.color};
    margin: 0;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.8rem 1.5rem 0.8rem 1.5rem;
    text-align: left;
  }

  .notice-heading {
    color: #9c4240;
    display: block;
    font-size: 1.125rem;
    font-weight: 500;
  }

  .notice-subheading {
    color: #9c4240;
    display: block;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.35;
    white-space: nowrap;

    a {
      color: #9c4240;
      text-decoration: underline;
    }
  }
`;
